import React, { useContext, useState } from 'react';
import { Button, Card, ListGroup } from 'react-bootstrap';
import { DebugContext } from '../../contexts/DebugContext';
import { IExtraProductGroup } from '../../models/IChainInfo';
import "../InteriorEditor/ProductGroup.scss"
import { ExtraProduct } from './ExtraProduct';

export function ExtraProductGroupCard(props: {
    productGroup: IExtraProductGroup
}) {

    const [collapsed, setCollapsed] = useState(true);
    const debugContext = useContext(DebugContext);

    const icon = collapsed
        ? "/imgs/icons/glyphicons-halflings-131-chevron-right.svg"
        : "/imgs/icons/glyphicons-halflings-128-chevron-down.svg"
        ;

    return (
        <Card className="extra-product-group product-group"
            data-collapsed={collapsed}
        >
            <Card.Header>
                <Button variant="btn-link btn-block text-left"
                    onClick={() => setCollapsed(!collapsed)}
                >
                    <img className="collapse-icon" src={icon} alt="" />
                    {debugContext.value.displayExtendedProductInfo && (props.productGroup.externalId + " - ")}
                    {props.productGroup.name}
                </Button>
            </Card.Header>

            <Card.Body>

                <ListGroup variant="flush" >
                    
                    {props.productGroup.products.map(p =>
                        <ExtraProduct product={p} key={p.id} />)
                    }
                </ListGroup>
            </Card.Body>

        </Card>
	);
}
